/**
 * dataFieldDirective
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

export function dataFieldDirective() {
    return {
        restrict: 'E',
        transclude: {
            actions: '?appDataFieldActions',
            suffix: '?appSuffix',
            hint: '?hint',
        },
        //language=HTML
        template: `
            <label>
                {{ label }}
            </label>

            <div class="app-data-field-inner">
                <div class="app-data-field-content"
                     ng-click="onContentClick({ $event: $event })"
                     md-ink-ripple="{{ clickable }}"
                     ng-class="{ 'is-clickable': clickable, 'is-empty': isContentEmpty }"
                     ng-transclude
                     data-empty="{{ empty }}">
                    <span ng-if="contentHtml" ng-bind-html="contentHtml"></span>
                    <span ng-if="content && !contentHtml">{{ content }}</span>
                    <span ng-if="!content.length && !contentHtml.length" class="empty">{{ empty }}</span>
                </div>

                <div class="app-data-field-suffix" ng-transclude="suffix"></div>
                
                <div class="app-data-field-actions">
                    <div ng-transclude="actions"></div>
                    
                    <md-button class="md-icon-button" ng-if="hint">
                        <md-icon>help</md-icon>
                        <md-tooltip>{{ hint }}</md-tooltip>
                    </md-button>
                </div>
            </div>

            <div class="app-data-field-hint" ng-transclude="hint"></div>
        `,
        scope: {
            content: '=content',
            contentHtml: '=?contentHtml',
            empty: '@empty',
            hint: '@hint',
            label: '@label',
            onContentClick: '&onContentClick',
        },
        link: function(scope, element, attributes) {
            const $content = element[0].querySelectorAll('.app-data-field-content')[0];

            scope.isContentEmpty = false;
            scope.clickable = !!attributes.onContentClick;

            scope.$watch(
                () => attributes.onContentClick,
                value => {
                    scope.clickable = !!value;
                },
            );

            scope.$watch(
                () => $content.textContent,
                value => {
                    scope.isContentEmpty = value.trim().length <= 0;
                },
            );
        },
    };
}
